import React, { lazy } from "react";
import LazyLoader from "./LazyLoader";

// Create wrapped lazy components that include the LazyLoader
const createLazyComponent = (importFunc) => {
	const LazyComponent = lazy(importFunc);
	return (props) => (
		<LazyLoader>
			<LazyComponent {...props} />
		</LazyLoader>
	);
};

// Lazy load heavy page components
export const LazyUserInternalManagement = createLazyComponent(() => import("pages/userManagment/userInternalManagment"));
export const LazyUserExternalManagement = createLazyComponent(() => import("pages/userManagment/userExternalManagment"));
export const LazySupplierManagement = createLazyComponent(() => import("pages/suppliersManagment/suppliersManagment"));
export const LazyWbsManagement = createLazyComponent(() => import("pages/wbsManagment/wbsManagment"));
export const LazyYardManagement = createLazyComponent(() => import("pages/yardManagment/yardManagment"));
export const LazyRoleManagement = createLazyComponent(() => import("pages/roleMenagment/roleMenagment"));

// Lazy load report components (usually heavy with charts/tables)
export const LazyJournalReport = createLazyComponent(() => import("pages/stampe/journalReport"));
export const LazyPayRoll = createLazyComponent(() => import("pages/stampe/payRoll"));
export const LazyWbsReport = createLazyComponent(() => import("pages/stampe/wbsReport"));
export const LazyUserWbsReport = createLazyComponent(() => import("pages/stampe/userWbsReport"));
export const LazyGDL = createLazyComponent(() => import("pages/stampe/GDL"));

// Lazy load security components (admin-heavy)
export const LazySecurityDocumentManagement = createLazyComponent(() => import("pages/security/SecurityDocumentManagment"));
export const LazyManagementSecuritySupplier = createLazyComponent(() => import("pages/security/managmentSecuritySupplier"));
export const LazyManageYardSecurityAdmin = createLazyComponent(() => import("pages/security/manageYardSecurityAdmin"));

// Lazy load quality components (complex forms/tables)
export const LazyConcreteDLWithdrawalReportManagement = createLazyComponent(() => import("pages/quality/concreteDLWithdrawalReportMenagment"));
export const LazyConcreteCastingRegistrationManagement = createLazyComponent(() => import("pages/quality/concreteCastingRegistrationManagment"));
export const LazyConcreteResultManagement = createLazyComponent(() => import("pages/quality/concreteResultManagment"));
